import type { SubmodelDescriptor } from '../../Descriptors/SubmodelDescriptor';
import type { PagedResult } from '../Interfaces/PagedResult';
import type { PagingParams } from '../Interfaces/PagingParams';
import { assertValidAasResponse, assignPagingParams } from '../../Utils/Restutils';
import { ClientBase } from './ClientBase';

export class SubmodelRegistryClient extends ClientBase {
  public async getSubmodelDescriptors(
    pagingParams?: PagingParams,
    signal?: AbortSignal,
  ): Promise<PagedResult<SubmodelDescriptor>> {
    const params = new URLSearchParams();
    assignPagingParams(params, pagingParams);
    const [request, response] = await this.request(
      'get',
      '/submodel-descriptors',
      params,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async createSubmodelDescriptor(
    descriptor: SubmodelDescriptor,
    signal?: AbortSignal,
  ): Promise<SubmodelDescriptor> {
    const [request, response] = await this.request(
      'post',
      '/submodel-descriptors',
      undefined,
      JSON.stringify(descriptor),
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async getSubmodelDescriptor(
    id: string,
    signal?: AbortSignal,
  ): Promise<SubmodelDescriptor> {
    const [request, response] = await this.request(
      'get',
      `/submodel-descriptors/${id}`,
      undefined,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response);
  }

  public async replaceSubmodelDescriptor(
    id: string,
    descriptor: SubmodelDescriptor,
    signal?: AbortSignal,
  ): Promise<void> {
    const [request, response] = await this.request(
      'put',
      `/submodel-descriptors/${id}`,
      undefined,
      JSON.stringify(descriptor),
      signal,
    );
    return await assertValidAasResponse(request, response, 'void');
  }

  public async deleteSubmodelDescriptor(
    id: string,
    signal?: AbortSignal,
  ): Promise<void> {
    const [request, response] = await this.request(
      'delete',
      `/submodel-descriptors/${id}`,
      undefined,
      undefined,
      signal,
    );
    return await assertValidAasResponse(request, response, 'void');
  }
}
